module.exports = __webpack_public_path__ + "img/Persiapan.234b9222.svg";